import Ajv from 'ajv';
import { JSONSchemaBridge } from 'uniforms-bridge-json-schema';
import addFormats from 'ajv-formats';

// Configurazione di base di Ajv
const ajv = new Ajv({
    allErrors: true,
    useDefaults: true,
    keywords: ['uniforms'],
    strict: false
});

addFormats(ajv);

// Funzione di validazione semplice
function createValidator(schema) {
    const validator = ajv.compile(schema);

    return (model) => {
        const isValid = validator(model);
        if (isValid) return null;
        return { details: validator.errors };
    };
}

export const createSchemaBridge = (schema) => {
    // Validazione di base dello schema
    if (!schema || schema.type !== 'object') {
        throw new Error('Invalid schema: must be an object type');
    }

    const validator = createValidator(schema);
    return new JSONSchemaBridge({
        schema,
        validator
    });
};